/**
 * This type defines the position of the mouse
 */
type Position = {
  x: number;
  y: number;
  lastX: number;
  lastY: number;
};

/**
 * This function checks if the user clicked on the modal or dragged it
 * @param target - The position of the mouse
 * @returns true if the user clicked on the modal, false if the user dragged it
 */
export function IsClickModal(target: Position) {
  const isClick =
    Math.abs(target.x - target.lastX) < 5 &&
    Math.abs(target.y - target.lastY) < 5;

  return isClick;
}
